import React, { useEffect } from "react";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch } from "redux-store/store";
import {
  getSingleteam,
  deleteSingleteam,
  errorClean,
  messageClean,
} from "redux-store/care-team/care-team.slice";
import { useParams, useNavigate, Link } from "react-router-dom";
import {
  singleteam,
  successMessage,
  teamError,
} from "redux-store/care-team/care-team.selector";
import { user } from "redux-store/user/user.selectors";

type Props = {};

export default function ContactInfo({}: Props) {
  const dispatch = useDispatch<AppDispatch>();
  const params = useParams();
  const navigate = useNavigate();
  const team = useSelector(singleteam);
  const teamerror = useSelector(teamError);
  const teamMessage = useSelector(successMessage);

  useEffect(() => {
    dispatch(errorClean());
    dispatch(messageClean());
    if (teamMessage !== "") {
      dispatch(errorClean);
      dispatch(messageClean);
      navigate("/user/care-team");
    }
    dispatch(getSingleteam(params.teamId));
  }, [teamMessage]);

  function handleDelete() {
    dispatch(deleteSingleteam(team?._id));
  }

  return (
    <div className=" tw-px-5 md:tw-px-16 tw-flex tw-flex-col tw-gap-16">
      <Link
        to={`/user/care-team`}
        className="tw-hidden md:tw-inline-block sm:tw-text-[20px] tw-text-black hover:tw-text-gray-700"
      >
        <KeyboardBackspaceIcon />
        <span className="tw-pl-2">BACK TO CARE TEAM</span>
      </Link>

      <div className=" tw-pt-10 tw-p-8 sm:tw-p-10 md:tw-p-12 tw-bg-[#FFFFFF] tw-w-full tw-rounded-2xl tw-shadow-3xl">
        <div>
          <span className="tw-font-bold tw-text-[36px]">
            {team?.veterinarianName && team?.veterinarianName !== ""
              ? team?.veterinarianName
              : "None"}
          </span>
        </div>
        <div>
          <div className="tw-flex tw-flex-col sm:tw-flex-row tw-gap-5 tw-text-[18px] md:tw-text-[20px]">
            <div className="tw-flex tw-flex-wrap tw-justify-between tw-w-full">
              <div className="tw-pt-3 sm:tw-pt-8 sm:tw-mr-7 md:tw-mr-0 lg:tw-w-1/4 tw-w-full sm:tw-w-1/2 tw-flex tw-flex-col tw-justify-start">
                <span className="tw-font-bold">Hospital Name</span>
                <span className="tw-text-[18px] md:tw-text-[22px] tw-font-light">
                  {team?.hospitalName && team?.hospitalName !== ""
                    ? team?.hospitalName
                    : "None"}
                </span>
              </div>

              <div className="tw-pt-3 sm:tw-pt-8 sm:tw-mr-7 md:tw-mr-0 tw-w-full sm:tw-w-1/2 lg:tw-w-1/4  tw-flex tw-flex-col tw-justify-start">
                <span className="tw-font-bold">Email</span>
                <span className="tw-text-[18px] md:tw-text-[22px] tw-font-light tw-truncate">
                  {team?.email && team?.email !== "" ? team?.email : "None"}
                </span>
              </div>

              <div className="tw-pt-3 sm:tw-pt-8 sm:tw-mr-7 md:tw-mr-0 lg:tw-w-1/4 tw-w-full sm:tw-w-1/2 tw-flex tw-flex-col tw-justify-start">
                <span className="tw-font-bold">Phone</span>
                <span className="tw-text-[18px] md:tw-text-[22px] tw-font-light">
                  {team?.phone && team?.phone !== "" ? team?.phone : "None"}
                </span>
              </div>

              <div className="tw-pt-3 sm:tw-pt-8 sm:tw-mr-7 md:tw-mr-0  lg:tw-w-1/4 tw-w-full sm:tw-w-1/2 tw-flex tw-flex-col tw-justify-start">
                <span className="tw-font-bold">Zip Code</span>
                <span className="tw-text-[18px] md:tw-text-[22px] tw-font-light">
                  {team?.zipCode && team?.zipCode !== ""
                    ? team?.zipCode
                    : "None"}
                </span>
              </div>

              <div className="tw-pt-3 sm:tw-pt-8 sm:tw-mr-7 md:tw-mr-0 lg:tw-w-1/4 tw-w-full sm:tw-w-1/2 tw-flex tw-flex-col tw-justify-start">
                <span className="tw-font-bold">Address</span>
                <span className="tw-text-[18px] md:tw-text-[22px] tw-font-light">
                  {team?.address && team?.address !== ""
                    ? team?.address
                    : "None"}
                </span>
              </div>

              <div className="tw-pt-3 sm:tw-pt-8 sm:tw-mr-7 md:tw-mr-0 lg:tw-w-1/4 tw-w-full sm:tw-w-1/2 tw-flex tw-flex-col tw-justify-start">
                <span className="tw-font-bold">Apartment/Suite</span>
                <span className="tw-text-[18px] md:tw-text-[22px] tw-font-light">
                  {team?.apartment && team?.apartment !== ""
                    ? team?.apartment
                    : "None"}
                </span>
              </div>

              <div className="tw-pt-3 sm:tw-pt-8 sm:tw-mr-7 md:tw-mr-0 lg:tw-w-1/4 tw-w-full sm:tw-w-1/2 tw-flex tw-flex-col tw-justify-start">
                <span className="tw-font-bold">City</span>
                <span className="tw-text-[18px] md:tw-text-[22px] tw-font-light">
                  {team?.city && team?.city !== "" ? team?.city : "None"}
                </span>
              </div>

              <div className="tw-pt-3 sm:tw-pt-8 sm:tw-mr-7 md:tw-mr-0 lg:tw-w-1/4 tw-w-full sm:tw-w-1/2 tw-flex tw-flex-col tw-justify-start">
                <span className="tw-font-bold">State</span>
                <span className="tw-text-[18px] md:tw-text-[22px] tw-font-light">
                  {team?.state && team?.state !== "" ? team?.state : "None"}
                </span>
              </div>
            </div>
          </div>
        </div>
        {/* </div> */}
        <span className=" tw-text-xs tw-text-red-500">
          {teamerror ? teamerror.message : ""}
        </span>
        <span className=" tw-text-xs tw-text-red-500">
          {teamMessage ? "Deleted Successfully" : ""}
        </span>

        <div className="tw-flex tw-flex-col">
          <div className="tw-pt-4 lg:tw-pt-7 tw-flex tw-flex-col min-[375px]:tw-flex-row">
            <button
              className="tw-text-white tw-text-[16px] md:tw-text-[20px] tw-border-2  tw-px-[36px] sm:tw-px-[40px] tw-py-2 lg:tw-py-3 tw-rounded-[10px] tw-border-reddishOrange tw-bg-reddishOrange hover:tw-text-white hover:tw-bg-darkRed hover:tw-border-darkRed tw-cursor-pointer"
              onClick={() => {
                let path = "edit";
                navigate(`/user/care-team/add-care-team/${path}/${team?._id}`);
              }}
            >
              Edit
            </button>
            <button
              className="tw-border-2 tw-text-[16px] md:tw-text-[20px] tw-rounded-[10px] tw-mt-5 min-[375px]:tw-mt-0 min-[375px]:tw-ml-5 tw-px-[36px] sm:tw-px-[40px] tw-py-2 lg:tw-py-3 tw-border-black tw-text-black hover:tw-bg-slate-200 hover:tw-border-slate-200 hover:tw-text-black cursor-pointer"
              onClick={handleDelete}
            >
              Delete
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
